/**
* Initializes the site's sideBySide component.
* @constructor
* @param {Object} el - The site's sideBySide container element.
*/
const sideBySide = el => {
	const rows = el.querySelectorAll('.side-by-side__row')
	const ref = el.querySelector('.side-by-side__ref')

	const setContentSize = () => {
		rows.forEach(row => {
			const content = row.querySelector('.side-by-side__description')
			if(window.innerWidth >= 992) {
				const width = ref.getBoundingClientRect().width/2
				content.style.width = width + 'px'
			} else {
				content.style.width = null
			}
		})
	}

	setContentSize()

	window.addEventListener('resize', function(evt) {
		setContentSize()
	})
}
export default function(el) {
    sideBySide(el)
}
